import type { ReactElement, ReactNode } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";

import { useProject } from "@/hooks/api/useProject";

type ProjectMutableGateProps = {
  children: ReactNode;
};

/** Blocks write form routes when the project is inactivated. */
export function ProjectMutableGate({ children }: ProjectMutableGateProps): ReactElement | null {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams<{ projectId?: string; id?: string }>();
  const projectId = params.projectId ?? params.id;
  const projectQuery = useProject(projectId);
  const project = projectQuery.data;
  const blocked = project?.isActive === false;

  useEffect(() => {
    if (!blocked || !projectId) return;
    toast.error(t("projects.inactiveReadonly"));
    navigate(`/projects/${projectId}/overview`, { replace: true });
  }, [blocked, navigate, projectId, t]);

  if (!projectId || projectQuery.isLoading || blocked) {
    return null;
  }

  return <>{children}</>;
}
